/**
 * Site Notification functionality
 * Handles cookie-based dismissal and initialization
 */
(function (global, $) {
  "use strict";

  // Prevent duplicate initialization
  if (global.siteNotificationInitialized) {
    console.log("Site notification already initialized, skipping...");
    return;
  }

  // Use our utility functions (should be loaded before this file)
  const on =
    global.on ||
    function (element, event, handler, options) {
      const elements = Array.isArray(element) ? element : [element];
      elements.forEach((el) => {
        if (el && el.addEventListener) {
          el.addEventListener(event, handler, options);
        }
      });
      return () => {
        elements.forEach((el) => {
          if (el && el.removeEventListener) {
            el.removeEventListener(event, handler, options);
          }
        });
      };
    };

  const onDocumentReady =
    global.onDocumentReady ||
    function (callback) {
      if (document.readyState !== "loading") {
        setTimeout(callback, 0);
      } else {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
      }
    };

  // Helper functions for DOM manipulation
  const addClass = (element, className) => {
    if (element) element.classList.add(className);
  };

  const removeClass = (element, className) => {
    if (element) element.classList.remove(className);
  };

  // Cookie utility functions
  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  // Main notification functionality
  const initSiteNotification = () => {
    // Prevent duplicate initialization
    if (global.siteNotificationInitialized) {
      console.log("Site notification already initialized");
      return;
    }

    console.log("DOM loaded, initializing site notification...");

    const siteNotification = document.getElementById("site-notification");
    const notificationClose = document.querySelector(".alert-banner-close");

    console.log("Site notification elements found:", {
      siteNotification: !!siteNotification,
      notificationClose: !!notificationClose,
    });

    // Check if notification element exists
    if (!siteNotification) {
      console.log("Site notification element not found");
      return;
    }

    // Mark as initialized early to prevent duplicates
    global.siteNotificationInitialized = true;

    console.log("Setting up site notification functionality...");

    // Function to close notification
    function closeSiteNotification() {
      console.log("Closing site notification");
      addClass(siteNotification, "hidden");
      // Set cookie to hide for 30 days
      setCookie("site_notification_hidden", "true", 30);

      // WordPress/jQuery compatibility - trigger custom event
      if ($ && typeof $.fn.trigger === "function") {
        $(siteNotification).trigger("notification:closed");
      }
    }

    // Check if notification should be hidden on page load
    if (getCookie("site_notification_hidden") === "true") {
      console.log("Site notification hidden by cookie");
      addClass(siteNotification, "hidden");
      return; // Exit early if hidden
    }

    // Setup close button event listener
    let offClose;
    if (notificationClose) {
      offClose = on(notificationClose, "click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("Notification close button clicked");
        closeSiteNotification();
      });
    }

    // Close on escape key (optional - remove if not wanted)
    const offEscape = on(document, "keydown", (e) => {
      if (
        e.key === "Escape" &&
        siteNotification &&
        !siteNotification.classList.contains("hidden")
      ) {
        console.log("Escape key pressed, closing notification");
        closeSiteNotification();
      }
    });

    console.log("Site notification setup complete!");

    // Store cleanup functions for potential later use
    global.siteNotificationCleanup = () => {
      if (offClose) offClose();
      if (offEscape) offEscape();
      global.siteNotificationInitialized = false;
    };

    // Make close function available globally
    global.closeSiteNotification = closeSiteNotification;
  };

  // Initialize when DOM is ready - but only once
  onDocumentReady(() => {
    if (!global.siteNotificationInitialized) {
      initSiteNotification();
    }
  });

  // Make initialization function available globally
  global.initSiteNotification = initSiteNotification;
})(
  typeof window !== "undefined" ? window : this,
  typeof jQuery !== "undefined" ? jQuery : undefined
);
